import mapKnownValues from "../utils/mapKnownValues";

export type AddressResponse = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
};

export default class Address {
  addressLine1 = "";
  addressLine2 = "";
  city = "";
  state = "";
  zipCode = "";

  constructor(params: Partial<Address> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: AddressResponse) {
    return new Address(response);
  }
}
